module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.general_setting) ? _c('div', [_c('h4', {
    staticClass: "group__headline"
  }, [_vm._v("Automatic cancellation")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatic cancellation"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Days until automatic cancellation"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_cancel_orders_in_days),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_cancel_orders_in_days", $$v)
      },
      expression: "model.general_setting.auto_cancel_orders_in_days"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatically fill up stock"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_stock_refill),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_stock_refill", $$v)
      },
      expression: "model.general_setting.auto_stock_refill"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_stock_refill),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_stock_refill", $$v)
      },
      expression: "model.general_setting.auto_stock_refill"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Abandonded cart")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send reminder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_abandonded),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded", $$v)
      },
      expression: "model.general_setting.auto_abandonded"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_abandonded),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded", $$v)
      },
      expression: "model.general_setting.auto_abandonded"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "In how many minutes?"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_abandonded_in_minutes),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandonded_in_minutes", $$v)
      },
      expression: "model.general_setting.auto_abandonded_in_minutes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "BCC email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_abandoned_bcc),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_abandoned_bcc", $$v)
      },
      expression: "model.general_setting.auto_abandoned_bcc"
    }
  }), _vm._v(" "), _vm._l((_vm.modelOrigin), function(data, index) {
    return [(
      data.setting_key === 'auto_abandoned_bcc' &&
      _vm.origins.length &&
      _vm.isValidOrigin(data.origin_id)
    ) ? _c('div', {
      staticClass: "mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "grow-0 shrink-0 basis-32"
    }, [_vm._v("\n                        Setting for " + _vm._s(_vm.getOriginName(data.origin_id)) + "\n                    ")]), _vm._v(" "), _c('el-input', {
      model: {
        value: (_vm.modelOrigin[index].setting),
        callback: function($$v) {
          _vm.$set(_vm.modelOrigin[index], "setting", $$v)
        },
        expression: "modelOrigin[index].setting"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-4"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.onSubmitOriginSetting(
            data.id,
            _vm.modelOrigin[index].setting
          )
        }
      }
    }, [_vm._v("Save setting for\n                        " + _vm._s(_vm.getOriginName(data.origin_id)))])], 1)]) : _vm._e()]
  })], 2), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Outstanding payments")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send reminder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.unpaid_orders_alert_enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "unpaid_orders_alert_enabled", $$v)
      },
      expression: "model.general_setting.unpaid_orders_alert_enabled"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.unpaid_orders_alert_enabled),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "unpaid_orders_alert_enabled", $$v)
      },
      expression: "model.general_setting.unpaid_orders_alert_enabled"
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "In how many days?"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.model.general_setting.auto_reminder_in_days),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_reminder_in_days", $$v)
      },
      expression: "model.general_setting.auto_reminder_in_days"
    }
  })], 1), _vm._v(" "), _c('h4', {
    staticClass: "group__headline mt-20"
  }, [_vm._v("Automatically mark as delivered")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Automatically mark as delivered"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.general_setting.auto_update_delivered),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_update_delivered", $$v)
      },
      expression: "model.general_setting.auto_update_delivered"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.model.general_setting.auto_update_delivered),
      callback: function($$v) {
        _vm.$set(_vm.model.general_setting, "auto_update_delivered", $$v)
      },
      expression: "model.general_setting.auto_update_delivered"
    }
  }, [_vm._v("No")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5654f10a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Automation.vue
// module id = 538
// module chunks = 1